var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applyAudWrap"},[_c('div',{staticClass:"btn",style:({background:_vm.audition.theme || '#03a9f4'}),on:{"click":_vm.toAudition}},[_vm._v(_vm._s(_vm.audition.btnName || '申请试听'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }